import React from 'react';
/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="phone" size=32 />
 */

var Phone = function Phone() {
  return React.createElement(React.Fragment, null, React.createElement("g", {
    clipPath: "url(#clip0_9_312)"
  }, React.createElement("path", {
    d: "M24.7449 1.56897H7.94488C7.37355 1.56897 6.9104 2.03212 6.9104 2.60345V29.3966C6.9104 29.9679 7.37355 30.431 7.94488 30.431H24.7449C25.3162 30.431 25.7794 29.9679 25.7794 29.3966V2.60345C25.7794 2.03212 25.3162 1.56897 24.7449 1.56897Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94488 2.06897C7.6497 2.06897 7.4104 2.30827 7.4104 2.60345V29.3966C7.4104 29.6917 7.6497 29.931 7.94488 29.931H24.7449C25.0401 29.931 25.2794 29.6917 25.2794 29.3966V2.60345C25.2794 2.30827 25.0401 2.06897 24.7449 2.06897H7.94488ZM6.4104 2.60345C6.4104 1.75598 7.09741 1.06897 7.94488 1.06897H24.7449C25.5924 1.06897 26.2794 1.75598 26.2794 2.60345V29.3966C26.2794 30.244 25.5924 30.931 24.7449 30.931H7.94488C7.09741 30.931 6.4104 30.244 6.4104 29.3966V2.60345Z",
    fill: "#002D55"
  }), React.createElement("path", {
    d: "M23.3483 24.6897V5.40692C23.3483 4.83559 22.8851 4.37244 22.3138 4.37244L10.3965 4.37244C9.82521 4.37244 9.36206 4.83559 9.36206 5.40692L9.36206 24.6897C9.36206 25.261 9.82521 25.7242 10.3965 25.7242H22.3138C22.8851 25.7242 23.3483 25.261 23.3483 24.6897Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5225 6.12923C19.7178 6.3245 19.7178 6.64108 19.5225 6.83634L16.6984 9.66048C16.5031 9.85574 16.1866 9.85574 15.9913 9.66048C15.796 9.46522 15.796 9.14863 15.9913 8.95337L18.8154 6.12923C19.0107 5.93397 19.3273 5.93397 19.5225 6.12923Z",
    fill: "#002D55"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5708 8.16714C21.7661 8.3624 21.7661 8.67898 21.5708 8.87424L19.8639 10.5811C19.6687 10.7764 19.3521 10.7764 19.1568 10.5811C18.9616 10.3859 18.9616 10.0693 19.1568 9.87404L20.8637 8.16714C21.059 7.97188 21.3756 7.97188 21.5708 8.16714Z",
    fill: "#002D55"
  }), React.createElement("path", {
    d: "M16.3449 29.0345C16.8534 29.0345 17.2656 28.6223 17.2656 28.1138C17.2656 27.6053 16.8534 27.1931 16.3449 27.1931C15.8364 27.1931 15.4242 27.6053 15.4242 28.1138C15.4242 28.6223 15.8364 29.0345 16.3449 29.0345Z",
    fill: "#002D55"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_9_312"
  }, React.createElement("rect", {
    width: "20.6897",
    height: "30",
    fill: "white",
    transform: "translate(6 1)"
  }))));
};

export default Phone;